import {
	buildQueryString,
	getRoutePath
} from '@sporkbytes/routing';

const entityPathSegment = "delivery-drivers";
function bulkAssignMealProposals(axios, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["meal-proposals", "bulk-assign"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function sendDispatchMessage(axios, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["dispatch-message", "send"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function toggleDispatchNotifications(axios, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["dispatch-notifications"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function deliverMealProposal(axios, id, MealProposalId, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "meal-proposals", MealProposalId, "deliver"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function pickUpDeliveryGear(axios, id, MealProposalId, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "meal-proposals", MealProposalId, "pick-up", "delivery-gear"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function pickUpPurchaseOrder(axios, id, PurchaseOrderId, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "purchase-orders", PurchaseOrderId, "pick-up"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function arriveAtClientLocation(axios, id, MealProposalId, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "meal-proposals", MealProposalId, "arrive"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function leaveClientLocation(axios, id, MealProposalId, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "meal-proposals", MealProposalId, "leave"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function arriveAtPartnerLocation(axios, id, PurchaseOrderId, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "purchase-orders", PurchaseOrderId, "arrive"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function leavePartnerLocation(axios, id, PurchaseOrderId, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "purchase-orders", PurchaseOrderId, "leave"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function getAll(axios, queryStringConfig) {
	const config = {
		entityPathSegment,
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function get(axios, id, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function post(axios, body) {
	const config = {
		entityPathSegment
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function put(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
export {
	arriveAtClientLocation,
	arriveAtPartnerLocation,
	bulkAssignMealProposals,
	deliverMealProposal,
	get,
	getAll,
	leaveClientLocation,
	leavePartnerLocation,
	pickUpDeliveryGear,
	pickUpPurchaseOrder,
	post,
	put,
	sendDispatchMessage,
	toggleDispatchNotifications
};
